
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 9717","d":"M25 0A25 25 0 110 25 25 25 0 0125 0z","fill":"#1d213c"}}),_c('g',{attrs:{"data-name":"Group 41989","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 11392","d":"M25 40a15 15 0 1110.61-4.393A15 15 0 0125 40m0-28.426A13.423 13.423 0 1038.42 25 13.423 13.423 0 0025 11.574z"}}),_c('path',{attrs:{"data-name":"Path 11393","d":"M21.837 31.314a.79.79 0 01-.559-.232l-4.74-4.74a.794.794 0 011.123-1.123l4.178 4.18 10.495-10.5a.794.794 0 011.123 1.123L22.402 31.079a.778.778 0 01-.559.232z"}})])])
          )
        }
      }
    